import React from 'react';
import { Formik, Form as FormikForm } from 'formik';

const Form = FormikForm as unknown as React.ComponentType<
  React.PropsWithChildren<Record<string, unknown>>
>;

import { getTranslation } from 'helpers/getTranslation';

import { Button } from 'components/shared/Button';
import { Loading } from 'components/shared/Loading';

import { FormikField } from 'components/FormikField';
import { InputField } from 'components/FormikFields';

import {
  initialValues,
  validationSchema,
} from './ForgotPasswordForm.formConfig';

import styles from './ForgotPasswordForm.module.scss';

const ForgotPasswordForm = ({
  loading,
  emailFromAuth,
  onSubmit,
}: {
  loading: any;
  emailFromAuth: any;
  onSubmit: any;
}) => (
  <Formik
    enableReinitialize
    initialValues={{ ...initialValues, email: emailFromAuth }}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    <Form className={styles.form}>
      <FormikField
        name="email"
        component={InputField}
        controlProps={{ className: styles.field, label: 'Email' }}
      />
      <Button
        className={styles.button}
        type="submit"
        size="md"
        startIcon={loading && <Loading color="var(--color-white-primary)" />}
      >
        {getTranslation('forgot_password_page.reset_button')}
      </Button>
    </Form>
  </Formik>
);

export default React.memo(ForgotPasswordForm) as any;
